import { InjectionToken } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { GridSearchForm } from '@data-access/grid-views';

import { GridViewAbstract } from '../../abstracts';

export const GRID_FACADE_SERVICE = new InjectionToken<GridViewAbstract>(
  'GRID_FACADE_SERVICE',
);

export const GRID_SEARCH_FORM = new InjectionToken<FormGroup<GridSearchForm>>(
  'GRID_SEARCH_FORM',
);
